import { apiBase } from './apiBase'

export const inboundOrderApi = apiBase.injectEndpoints({
	endpoints: (builder) => ({
		fetchPurchaseOrderDelivery: builder.query({
			query: (sequenceNumber) => ({
				url: `purchaseOrderDelivery?sequenceNumber=${sequenceNumber}`,
				method: 'GET',
			}),
		}),
		savePurchaseOrderDelivery: builder.mutation({
			query: (payload) => ({
				url: 'purchaseOrderDelivery',
				method: 'PUT',
				body: payload,
			}),
		}),
		completeOrderDelivery: builder.mutation({
			query: (payload) => ({
				url: 'purchaseOrderDelivery',
				method: 'POST',
				body: payload,
			}),
		}),
		deleteInboundOrderRow: builder.mutation({
			query: ({ sequenceNumber, rowId }) => ({
				url: `purchaseOrderDelivery?sequenceNumber=${sequenceNumber}&rowId=${rowId}`,
				method: 'DELETE',
			}),
		}),
		setPurchaseOrderDeliveryUnloading: builder.mutation({
			query: (sequenceNumber) => ({
				url: `purchaseOrderDelivery/${sequenceNumber}/unloading`,
				method: 'POST',
			}),
		}),
		setPurchaseOrderDeliveryReady: builder.mutation({
			query: (sequenceNumber) => ({
				url: `purchaseOrderDelivery/${sequenceNumber}/ready`,
				method: 'POST',
			}),
		}),
	}),
})

export const {
	useFetchPurchaseOrderDeliveryQuery,
	useLazyFetchPurchaseOrderDeliveryQuery,
	useSavePurchaseOrderDeliveryMutation,
	useCompleteOrderDeliveryMutation,
	useDeleteInboundOrderRowMutation,
	useSetPurchaseOrderDeliveryUnloadingMutation,
	useSetPurchaseOrderDeliveryReadyMutation,
} = inboundOrderApi